export default {"src":"/_next/static/media/logo-ia.e593af7c.svg","height":18,"width":48,"blurWidth":0,"blurHeight":0};